"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationController = void 0;
const operators_1 = require("rxjs/operators");
const logger_1 = require("../../util/logger");
const streem_error_1 = require("../../streem_error");
const api_1 = require("@streem/api");
const domain_id_1 = require("@streem/domain-id");
const utils_1 = require("../wall/utils");
const last_created_at_1 = require("../../util/rx/last_created_at");
class InvitationController {
    constructor(config) {
        var _a, _b, _c, _d;
        this.config = config;
        this.invitations = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('roomInvitation'), (0, utils_1.accumulateAndMapWallEvents)('roomInvitation'), (0, operators_1.shareReplay)(1));
        this.incomingInvitation = this.invitations.pipe((0, utils_1.filterByProperty)('toUserSid', (_b = (_a = this.config.context.localUserId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : 'NEVER'), (0, last_created_at_1.lastCreatedAt)());
        this.incomingInvitationStatus = this.incomingInvitation.pipe((0, operators_1.map)(invitation => invitation.status || undefined));
        this.outgoingInvitation = this.invitations.pipe((0, utils_1.filterByProperty)('fromUserSid', (_d = (_c = this.config.context.localUserId) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : 'NEVER'), (0, last_created_at_1.lastCreatedAt)());
        this.outgoingInvitationStatus = this.outgoingInvitation.pipe((0, operators_1.map)(invitation => invitation.status || undefined));
    }
    createInvitation(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const { roomId } = this.config.context;
            try {
                const { roomInvitation } = yield api_1.StreemAPI.rooms.createRoomInvitation(roomId.toString(), {
                    fromDeviceSid: config.fromDeviceId.toString(),
                    fromUserSid: config.fromUserId.toString(),
                    toUserSid: config.toUserId.toString(),
                });
                if (!roomInvitation || !roomInvitation.sid) {
                    throw new streem_error_1.StreemError('Unable to create room invitation.');
                }
                logger_1.logger.info(`Invitation ${roomInvitation.sid} sent to user ${config.toUserId} for room ${roomId}`);
                return new domain_id_1.RoomInvitationId(roomInvitation.sid);
            }
            catch (e) {
                logger_1.logger.error('Error creating room invitation.', config, e);
                throw new streem_error_1.StreemError('An internal error occurred sending your Streem invite.');
            }
        });
    }
    cancelInvitation(invitationId) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO don't allow cancel of incoming invitation
            logger_1.logger.info(`Invitation ${invitationId} canceled`);
            yield api_1.StreemAPI.rooms.cancelRoomInvitation(this.config.context.roomId.toString(), invitationId.toString());
        });
    }
}
exports.InvitationController = InvitationController;
//# sourceMappingURL=invitation_controller.js.map